import { Video } from "@admin/config/blocks/Video";
import { Hero } from "@admin/config/blocks/Hero";
import { Features } from "@admin/config/blocks/Features";
import { AnchorLinks } from "@admin/config/blocks/AnchorLinks";
import { Tabs } from "@admin/config/blocks/Tabs";
import { ArchStandalone } from "@admin/config/blocks/ArchStandalone";
import { BasicSection } from "@admin/config/blocks/BasicSection";
import { CallRates } from "@admin/config/blocks/CallRates";
import { CallRatesSearch } from "@admin/config/blocks/CallRatesSearch";
import { Cards } from "@admin/config/blocks/Cards";
import { ComparePricing } from "@admin/config/blocks/ComparePricing";
import { Contact } from "@admin/config/blocks/Contact";
import { Cta } from "@admin/config/blocks/Cta";
import { Button } from "@admin/config/blocks/Button";
import { FlexBox } from "@admin/config/blocks/FlexBox";
import { GridBox } from "@admin/config/blocks/GridBox";
import { Paragraph } from "@admin/config/blocks/Paragraph";
import { Heading } from "@admin/config/blocks/Heading";
import { Image } from "@admin/config/blocks/Image";
import { Reviews } from "@admin/config/blocks/Reviews";
import { LogosBanner } from "@admin/config/blocks/LogosBanner";
import { MiniArticles } from "@admin/config/blocks/BlogsAndNews";
import { Navigation } from "@admin/config/blocks/Navigation";
import { Footer } from "@admin/config/blocks/Footer";
import { PricingSection } from "@admin/config/blocks/PricingSection";
import { FaqAccordion } from "@admin/config/blocks/FaqAccordion";
import { BentoBox } from "@admin/config/blocks/BentoBox";
import { DeliveryTerms } from "@admin/config/blocks/DeliveryTerms";
import { SearchLinks } from "@admin/config/blocks/SearchLinks";
import { LegacyBento } from "@admin/config/blocks/LegacyBento";
import { NumberTransfer } from "@admin/config/blocks/NumberTransfer";
import { NumberPicker } from "@admin/config/blocks/NumberPicker";
import { ComparisonTable } from "@admin/config/blocks/ComparisonTable";
import { DomainNamePricingTable } from "@admin/config/blocks/DomainNamePricingTable";
import { DomainNameSearchResults } from "@admin/config/blocks/DomainNameSearchResults";
import { DomainNameBulkSearchResults } from "@admin/config/blocks/DomainNameBulkSearchResults";
import { DomainNameSearchBackorder } from "@admin/config/blocks/DomainNameSearchBackorder";
import { DomainNameSearchTabs } from "@admin/config/blocks/DomainNameSearch";
import { DomainNameTldSearch } from "@admin/config/blocks/DomainNameTldSearch";
import { DomainNamePricingCards } from "@admin/config/blocks/DomainNamePricingCards";
import { DomainNameSearchTransfer } from "@admin/config/blocks/DomainNameSearchTransfer";
import { Steps } from "@admin/config/blocks/Steps";

const blocks = {
  Video,
  Hero,
  Features,
  Tabs,
  AnchorLinks,
  ArchStandalone,
  BasicSection,
  CallRates,
  CallRatesSearch,
  Cards,
  ComparePricing,
  Contact,
  Cta,
  FlexBox,
  Button,
  GridBox,
  Paragraph,
  Heading,
  Image,
  Reviews,
  LogosBanner,
  MiniArticles,
  Navigation,
  Footer,
  PricingSection,
  FaqAccordion,
  BentoBox,
  DeliveryTerms,
  SearchLinks,
  LegacyBento,
  NumberTransfer,
  NumberPicker,
  ComparisonTable,
  DomainNameBulkSearchResults,
  DomainNameSearchResults,
  DomainNamePricingTable,
  DomainNameSearchBackorder,
  DomainNameSearchTabs,
  DomainNameTldSearch,
  DomainNamePricingCards,
  DomainNameSearchTransfer,
  Steps,
};

const orderedBlocks = Object.keys(blocks)
  .map((b) => blocks[b].label)
  .sort()
  .reduce((acc, label) => {
    const block = Object.keys(blocks).find((b) => blocks[b].label === label);
    if (!block) return acc;
    acc[block] = blocks[block];
    return acc;
  }, {});

export default orderedBlocks;
